import { Module, ActionContext } from "vuex"
import ajax from "@/lib/ajax"
import { AbpApiResponse, ValidationResult } from "../models/common"
import util from "@/lib/util"
// import {
//   VcpOnlineOk_AttachmentSummaryDto,
//   VcpOnlineOk_AttachmentInputDto,
//   VcpOnlineOk_VcClaimSummaryLightDto,
//   VcpOnlineOk_ApplicationDto,
//   VcpOnlineOk_VcClaimDto,
//   VcpOnlineOk_OkVcClaimLogDto,
//   VcpOnlineOk_AppCrimeVictimDto,
//   VcpOnlineOk_AppAddressDto,
//   VcpOnlineOk_AppClaimantDto,
//   VcpOnlineOk_VcClaimSummaryDto,
//   PublicUserSummary,
// } from "@/asdcom/apiproxy/apiproxy.dto.vcponlineok.ts"
import {  VcClaimDto, IStaffTaskCountDto } from "@/asdcom/apiproxy/apiproxy.dto.ts"

const _hostUrl = "https://ocvcapp-api-dev.heart4victims.org"

interface VcpOnlineOkState {
  applicantRequestsCount: number | undefined,
  claimTasksCount: number | undefined,
  remindersCount: number | undefined,
  applicantRequestTaskList:any[],
  currentClaim: VcClaimDto| undefined
}
interface SetApplicantAsClaimantInput {
  applicant: any //ApplicantDto
  claimantSsn: string
}

class VcpOnlineOkStore implements Module<VcpOnlineOkState, any> {
  namespaced = true
  state: VcpOnlineOkState = {
    applicantRequestsCount: undefined,
    claimTasksCount: undefined,
    remindersCount: undefined,
    applicantRequestTaskList:[],
    currentClaim: undefined
  }

  getters = {
    getApplicantRequestTaskList(state:VcpOnlineOkState){
      abp.log.debug({"vcponlineok.staff.ts state":state.applicantRequestTaskList});
      return state.applicantRequestTaskList;
    },
    getCurrentClaim(state:VcpOnlineOkState) {
      abp.log.debug({"vcponlineok.staff getter":state.currentClaim});
      if (state.currentClaim !== undefined) {
        return state.currentClaim;
      }
    }
  }
  mutations = {
    setDashboardCounts(state: VcpOnlineOkState, payload: IStaffTaskCountDto) {
      state.applicantRequestsCount = payload.applicantRequestsCount;
      state.claimTasksCount = payload.claimTasksCount;
      state.remindersCount = payload.remindersCount;
    },
    applicantRequestTaskList(state:VcpOnlineOkState, payload:any){
      // abp.log.debug({"vcponlineok.staff.ts payload":payload});
      state.applicantRequestTaskList = payload;
    },
    setCurrentClaim(state:VcpOnlineOkState, payload: VcClaimDto) {
      state.currentClaim = payload;
    }
  }
  actions = {

    async GetSubmissionPdf(context: ActionContext<VcpOnlineOkState, any>, payload: { vcClaimId: string; submissionId: string }) {
      abp.log.debug({ getSubmissionPdf: { claimid: payload.vcClaimId, submmId: payload.submissionId } })
      // Get temporary token.
      const form = new FormData()
      form.append("claimId", payload.vcClaimId)
      form.append("submissionId", payload.submissionId)

      const tokenResp = await ajax.post<AbpApiResponse<string>>("/api/TokenAuth/GetTokenForHTTPGet", form)
      //abp.log.debug({"GetToken resp":tokenResp})
      // Build file url.
      const fileUrl = `${tokenResp.config.baseURL}/api/services/app/VcpOnlineOkService/GetSubmissionPdfFile?TempToken=Bearer ${tokenResp.data.result}`

      //abp.log.debug({"file url":resp});
      const url = fileUrl
      const link = document.createElement("a")
      link.href = url
      link.target = "_blank"
      link.setAttribute("download", `claim-docs.pdf`) //or any other extension
      document.body.appendChild(link)
      link.click()

    },

  }
}

const vcponlineok = new VcpOnlineOkStore()
export default vcponlineok
